import { MobileFiltersData } from '../filters.types';

type GenerateNumberOfActiveFilters = (value: MobileFiltersData[]) => number;

export const generateNumberOfActiveFilters: GenerateNumberOfActiveFilters = (
  data
) =>
  data.reduce<number>((acc, { value }) => {
    const isEmpty =
      value === null ||
      value === '' ||
      (Array.isArray(value) && value.length === 0);

    if (!isEmpty) {
      return (acc += 1);
    }

    return acc;
  }, 0);
